import http from '../utilities/http-common'

const saveEvents = (event) => {
    return http.post('/api/v1/events/save', event)
}

export default {
    saveEvents
}
